import { Grid, Typography } from '@mui/material';
import { useParams } from 'react-router';
import AppContainer from 'src/components/appComponents/AppContainer';
import { useGetParentSuggestionByIdQuery } from 'src/graphql';
import { paths } from 'src/routes/paths';
import PublishChannelParentSuggestionForm from 'src/sections/parentSuggestions/PublishChannelParentSuggestionForm';
import PublishParentSuggestionForm from 'src/sections/parentSuggestions/PublishParentSuggestionForm';

export default function PublishParentSuggestionPage() {
  const { suggestedId } = useParams();

  const { data: suggestionVideo, isLoading: isLoadingGetSuggestionVideo } =
    useGetParentSuggestionByIdQuery({
      id: suggestedId,
    });

  return (
    <AppContainer
      pageTitle="Publish"
      routeLinks={[
        { name: 'Parent Suggestions' },
        // {
        //   name: 'Suggestions',
        //   href: `${paths.dashboard.parentSuggestions.suggestions}`,
        // },
        {
          name: 'View',
          href: `${paths.dashboard.parentSuggestions.suggestionDetails(suggestedId ?? '')}`,
        },
        {
          name: 'Publish',
        },
      ]}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} mb={4}>
          <Typography variant="h4" color="primary">
            Parent Suggestion Info
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {suggestionVideo?.app_suggested_by_pk?.type == 'video' ? (
            <PublishParentSuggestionForm
              suggestionVideo={suggestionVideo}
              isLoadingGetSuggestionVideo={isLoadingGetSuggestionVideo}
            />
          ) : (
            <PublishChannelParentSuggestionForm
              suggestionVideo={suggestionVideo}
              isLoadingGetSuggestionVideo={isLoadingGetSuggestionVideo}
            />
          )}
        </Grid>
      </Grid>
    </AppContainer>
  );
}
